export { default } from '@/features/events/feed/EventsScreen';
